import { createStore } from 'vuex';
import auth from './modules/auth';
import axios from 'axios';
import { apiConfig } from '@/utils/config';
import { useToast } from 'vue-toastification';

const store = createStore({
    state: {
        showSpinner: false,
        showAfterSave: false,
        showAdminHeader: true,
        confirmModal: {
            isVisible: false,
            message: '',
            resolve: null
        },
        costings: [{
            syspk_costing: 0
        }],
        recentPages: [] // Added for recent pages tracking
    },
    mutations: {
        SHOW_SPINNER(state) {
            state.showSpinner = true;
        },
        HIDE_SPINNER(state) {
            state.showSpinner = false;
        },
        SET_COSTINGS(state, { costings }) {
            state.costings = costings;
        },
        SHOW_CONFIRM_MODAL(state, { message, resolve }) {
            state.confirmModal.isVisible = true;
            state.confirmModal.message = message;
            state.confirmModal.resolve = resolve;
        },
        HIDE_CONFIRM_MODAL(state) {
            state.confirmModal.isVisible = false;
            state.confirmModal.message = '';
            state.confirmModal.resolve = null;
        },
        SHOW_AFTER_SAVE(state, { value }) {
            state.showAfterSave = value;
        },
        SHOW_ADMIN_HEADER(state, { value }) {
            state.showAdminHeader = value;
        },
        // Added for recent pages tracking
        ADD_RECENT_PAGE(state, page) {
            // Remove if already exists
            state.recentPages = state.recentPages.filter(p => p.path !== page.path);
            // Add to beginning
            state.recentPages.unshift({
                ...page,
                timestamp: Date.now()
            });
            // Keep only last 10
            if (state.recentPages.length > 10) {
                state.recentPages = state.recentPages.slice(0, 10);
            }
            localStorage.setItem('recentpages',JSON.stringify(state.recentPages));

        },
        // Added for recent pages tracking
        ADD_RECENT_PAGES(state, pages) {
            if (pages?.length > 10) {
                state.recentPages = pages.slice(0, 10);
            }
            else{
                state.recentPages = pages;
            }
           // localStorage.setItem('recentpages',JSON.stringify(state.recentPages));

        },
        CLEAR_RECENT_PAGES(state) {
            state.recentPages = [];
        }
    },
    actions: {
        showSpinner({ commit }) {
            commit('SHOW_SPINNER');
        },
        showAfterSave({ commit }, value) {
            commit('SHOW_AFTER_SAVE', { value })
        },
        async getCostings({ commit }) {
            try {
                const response = await axios.get(`${apiConfig.baseUrl}v1/b/getcostings`);
                commit('SET_COSTINGS', { costings: response.data });
            }
            catch (err) {
                console.log('error getting costings', err);
            }
        },
        successToast(_, msg) {
            useToast().success(msg);
        },
        errorToast(_, msg) {
            useToast().error(msg);
        },
        showAdminHeader({ commit }, value) {
            commit('SHOW_ADMIN_HEADER', { value })
        },
        hideSpinner({ commit }) {
            commit('HIDE_SPINNER');
        },
        showConfirmModal({ commit }, message) {
            return new Promise((resolve) => {
                commit('SHOW_CONFIRM_MODAL', { message, resolve });
            });
        },
        hideConfirmModal({ commit }) {
            commit('HIDE_CONFIRM_MODAL');
        },
        confirmYes({ state, dispatch }) {
            if (state.confirmModal.resolve) {
                state.confirmModal.resolve(true);
                dispatch('hideConfirmModal');
            }
        },
        confirmNo({ state, dispatch }) {
            if (state.confirmModal.resolve) {
                state.confirmModal.resolve(false);
                dispatch('hideConfirmModal');
            }
        },
        // Added for recent pages tracking
        trackPageVisit({ commit }, page) {
            commit('ADD_RECENT_PAGE', page);
        },
         addPages({ commit }, pages) {
            commit('ADD_RECENT_PAGES', pages);
        },
        clearRecentPages({ commit }) {
            commit('CLEAR_RECENT_PAGES');
        }
    },
    getters: {
        // Added for recent pages tracking
        recentPages: (state) => state.recentPages
    },
    modules: {
        auth
    }
});

export default store;